// extracted by mini-css-extract-plugin
export default {"container":"SignUp_container__og7fU","signup":"SignUp_signup__LiCwK","alert":"SignUp_alert__I3US4","confirmation":"SignUp_confirmation__x5lyN"};